<template>
    <v-container style="margin-top:0px; padding-top:0px;">
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Preload Order To Shift</v-toolbar-title
                >
                <v-spacer />
                <v-btn
                    icon
                    left
                    @click="$store.state.dispatch.potoshift = false"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>

            <v-container style="marginl-left:10%;">
                <v-row style="margin: 0 10%">
                    <v-combobox
                        @click:prepend="loadShiftsDet($event)"
                        @change="loadShiftsDet($event)"
                        :items="shiftHeadersFiltered"
                        :item-text="'ShiftDate'"
                        :item-value="'ShiftId'"
                        label="Select Shift"
                        class="scroller"
                        auto-select-first
                    ></v-combobox>
                </v-row>
                <v-divider></v-divider>

                <template>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="shiftsDetFiltered"
                        :single-select="true"
                        item-key="ShiftDetail"
                        show-select
                        class="elevation-1"
                    >
                        <template v-slot:item.SpecificProduct="{ item }">
                            {{ item.SpecificProduct }}
                        </template>
                    </v-data-table>
                </template>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" @click="preloadOrderToShift()">
                        Preload Order To Shift
                    </v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: ['shiftHeaders', 'orderRequired'],
    data: function() {
        return {
            currentLoadNum: 0,
            uniqueLoadNumArr: [],
            currentOrders: [],
            shiftHeadersFiltered: [],
            // shiftsDet: [],
            shiftsDetFiltered: [],
            selected: [],
            headers: [
                {
                    text: 'Shift #',
                    align: 'start',
                    sortable: false,
                    value: 'ShiftDetail'
                },
                { text: 'Driver', value: 'Driver' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Trailer', value: 'Trailer' },
                { text: 'Yard', value: 'Yard' },
                { text: 'Specific Product', value: 'SpecificProduct' }
            ],
            shiftDetailOrigin: null
        };
    },
    mounted() {
        console.log(this.shiftHeadersm, this.orderRequired);
        this.shiftHeadersRequired();
    },
    methods: {
        filterLoadNumbers: function() {
            let loadNumArr = [];
            for (let ord of this.currentOrders) {
                loadNumArr.push(ord.LoadNum);
            }

            this.uniqueLoadNumArr = loadNumArr.filter((value, index, array) => {
                return array.indexOf(value) === index;
            });

            console.log(this.uniqueLoadNumArr);

            this.currentLoadNum = this.uniqueLoadNumArr.length;
            this.preloadOrder(this.orderRequired);
        },
        getCurrentOrders: async function(shiftDetail) {
            await axios
                .get('order/shift/' + shiftDetail)
                .then(response => {
                    console.log(response.data.data);
                    this.currentOrders = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.filterLoadNumbers();
        },
        preloadOrderToShift: function() {
            var str = this.$store;
            if (this.selected.length === 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select a shift!'
                });
                return;
            }

            console.log('Prelodeando orden con un shift...');
            console.log(this.selected);

            this.getCurrentOrders(this.selected[0].ShiftDetail);
        },
        shiftHeadersRequired: function() {
            const today = new Date();
            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today
                .getDate()
                .toString()
                .padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            // console.log(formattedDate);

            this.shiftHeadersFiltered = [];

            for (let sh of this.shiftHeaders) {
                let [date, time] = sh.ShiftDate.split(' ');
                console.log(time);
                if (date >= formattedDate) {
                    this.shiftHeadersFiltered.push(sh);
                } else {
                    break;
                }
            }

            console.log(this.shiftHeadersFiltered);
            console.log(this.orderRequired);
        },
        loadShiftsDet: async function(e) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            await axios
                .get('shift-detail/shift/' + e.ShiftId)
                .then(response => {
                    let shiftsDet = response.data;
                    let activeTrailer = this.orderRequired[0].Trailer;
                    console.log(shiftsDet);
                    console.log(activeTrailer);
                    this.filterShiftsByTrailer(shiftsDet, activeTrailer);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        filterShiftsByTrailer: function(shiftsDet, activeTrailer) {
            this.shiftsDetFiltered = [];

            for (let shDet of shiftsDet) {
                if (shDet.Trailer === activeTrailer) {
                    let {
                        ShiftDetail,
                        Driver,
                        Truck,
                        Trailer,
                        TrailerID,
                        Yard,
                        ShiftStartTime,
                        SpecificProductOnly,
                        SpecificProduct
                    } = shDet;
                    this.shiftsDetFiltered.push({
                        ShiftDetail,
                        Driver,
                        Truck,
                        Trailer,
                        TrailerID,
                        Yard,
                        ShiftStartTime,
                        SpecificProductOnly,
                        SpecificProduct
                    });
                }
            }

            console.log(this.shiftsDetFiltered);
            this.$store.state.isLoading = false;
        },
        preloadOrder: async function(order) {
            var str = this.$store;
            str.state.isLoading = true;
            console.log(order);
            var check = true;
            this.shiftDetailOrigin = order[0].ShiftDetail;

            await order.forEach(ord => {
                if (
                    this.selected[0].SpecificProductOnly == ord.isSpecific ||
                    (this.selected[0].SpecificProductOnly == null &&
                        ord.isSpecific == 0)
                ) {
                    console.log(ord.isSpecific);
                } else {
                    check = false;
                }
            });
            if (check == false) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Specific product does not match trailer'
                });
                str.state.isLoading = false;
            } else {
                // "order" es un arreglo y puede tener 1 objeto (una orden) o más
                for (let ord of order) {
                    await axios
                        .get('order/preload/' + ord.OrderID, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        .then(response => {
                            console.log(response);
                        })
                        .catch(function(error) {
                            this.$store.state.isLoading = false;
                            console.log(error);
                        });
                }

                str.state.isLoading = false;
                this.assignLoad(order, this.selected[0]);
            }
        },
        assignLoad: async function(order, shift) {
            this.$store.state.isLoading = true;
            console.log('assignLoad', order, shift);
            console.log(this.currentLoadNum);

            var str = this.$store;

            for (let ord of order) {
                await axios
                    .get(
                        'order/check/preload/' +
                            shift.TrailerID +
                            '/' +
                            ord.OrderID,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(async response => {
                        if (response.data.length == 0) {
                            str.dispatch('setSnackbar', {
                                color: 'danger',
                                text: 'This trailer does not match the preload!'
                            });
                        } else {
                            // Consult the shift origin for the order
                            let data = {
                                OrderIDs: [ord.OrderID],
                                ShiftDetail: shift.ShiftDetail
                            };
                            let origins = {};
                            await axios
                                .post('shift-detail/order-origin', data, {
                                    headers: {
                                        Authorization:
                                            'Bearer ' + this.$store.state.token
                                    }
                                })
                                .then(function(response) {
                                    //console.log("response->", response.data);
                                    origins = response.data;
                                })
                                .catch(error => {
                                    console.log(error);
                                });

                            console.log('Origins: ', origins);
                            let originsData = origins[ord.OrderID];
                            console.log(originsData);
                            let unknownOrigins = '';
                            if (originsData.length != 0) {
                                if (
                                    originsData[0].ShiftDetail ==
                                    shift.ShiftDetail
                                ) {
                                    unknownOrigins = '';
                                } else {
                                    unknownOrigins =
                                        originsData[0].DriverName +
                                        ' / ' +
                                        originsData[0].Date +
                                        ' ' +
                                        originsData[0].Shift;
                                }
                            }

                            var order_values = {
                                OrderStatus: 'PRLDISPAT',
                                ShiftDetail: shift.ShiftDetail,
                                OrdLoadStatus: 'READYTOSEND',
                                UnknownOrigins: unknownOrigins,
                                OrdActiveOrder: 1
                            };

                            if (ord.LoadNumOrd == null) {
                                order_values.LoadNum = ++this.currentLoadNum;
                            } else if (ord.LoadNumOrd == 1) {
                                order_values.LoadNum = ++this.currentLoadNum;
                                order_values.LoadNumOrd = ord.LoadNumOrd;
                            } else if (ord.LoadNumOrd >= 2) {
                                order_values.LoadNum = this.currentLoadNum;
                                order_values.LoadNumOrd = ord.LoadNumOrd;
                            }

                            axios
                                .put('order/' + ord.OrderID, order_values, {
                                    headers: {
                                        Authorization:
                                            'Bearer ' + this.$store.state.token
                                    }
                                })
                                .then(response => {
                                    console.log('Success Assign!', response);
                                    this.currentOrders.push(response.data);

                                    str.dispatch('setSnackbar', {
                                        color: 'success',
                                        text: 'Successful assignment'
                                    });

                                    this.updateLoadOrder();
                                })
                                .catch(function(error) {
                                    this.$store.state.isLoading = false;
                                    console.log(error);
                                    if (error.response.status === 403) {
                                        str.dispatch('setSnackbar', {
                                            color: 'error',
                                            text:
                                                'You do not have the permission to use this function.'
                                        });
                                    }
                                    if (error.response.status === 500) {
                                        str.dispatch('setSnackbar', {
                                            color: 'error',
                                            text:
                                                'An error has ocurred, please try again.'
                                        });
                                    }
                                });
                        }
                    })
                    .catch(function(error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }

            this.$emit('close', this.shiftDetailOrigin);
            this.$store.state.dispatch.potoshift = false;
            this.$store.state.isLoading = false;
        },
        updateLoadOrder: function() {
            console.log(this.selected[0]);
            console.log('Current Orders', this.currentOrders);

            var str = this.$store;
            var startTime = moment(this.selected[0].ShiftStartTime);
            var hrs = 0;
            var eta = null;
            var order_values = {};
            var gp = 0;
            var d1,
                d2,
                rt,
                ro = 0;

            for (let ord of this.currentOrders) {
                if (ord.LoadNumOrd == null) {
                    hrs = 3;
                    eta = startTime
                        .add(hrs, 'hours')
                        .format('YYYY-MM-DD HH:mm:ss');

                    console.log('--------------ETA', eta, ord.OrderID);

                    if (ord.RTTime > eta) {
                        rt = moment(ord.RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (ord.ROTime < eta) {
                        ro = moment(ord.ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }

                    order_values = {
                        ETATime: eta,
                        GoalPost: gp
                    };

                    // console.log("----------------------------", order_values, ord.OrderID);

                    axios
                        .put('order/' + ord.OrderID, order_values, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success! updateLoadOrder');
                        })
                        .catch(function(error) {
                            str.state.isLoading = false;
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                } else {
                    if (ord.LoadNumOrd > 1) {
                        hrs = 0.5;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        hrs = 3;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    }

                    if (ord.RTTime > eta) {
                        rt = moment(ord.RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (ord.ROTime < eta) {
                        ro = moment(ord.ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }

                    order_values = {
                        ETATime: eta,
                        GoalPost: gp
                    };

                    console.log(order_values);

                    axios
                        .put('order/' + ord.OrderID, order_values, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success!');
                        })
                        .catch(function(error) {
                            console.log(error);

                            this.$store.state.isLoading = false;
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                }
            }
        }
    }
};
</script>
<style></style>
